import { formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { map, Observable, of, Subscription } from 'rxjs';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';
import { FormBuilder, FormControl } from '@angular/forms';
import { ConfigService } from 'src/app/core/services/config.service';
import { Entity } from 'src/app/core/models/entity.model';
import { CustomValidators } from 'src/app/shared/helpers/custom-validators';
import { Category } from 'src/app/core/models/package.model';
import { BasicVirtualScrollComponent } from 'src/app/shared/components/basic-virtual-scroll/basic-virtual-scroll.component';


@Component({
  selector: 'hbo-analytics-filters',
  templateUrl: './analytics-filters.component.html',
  styleUrls: ['./analytics-filters.component.scss']
})
export class AnalyticsFiltersComponent {

  @Input() typeData!: string;
  @Output() reload = new EventEmitter<{ [key: string | number]: any }>();

  @ViewChild(BasicVirtualScrollComponent) childComp!: BasicVirtualScrollComponent;

  apply_filters_pb!: boolean;
  filters_applyed!: boolean;

  private readonly MAX_MONTHS = 4;

  private defaultStartDate(): string {
    const d = new Date();
    d.setMonth(d.getMonth() - this.MAX_MONTHS);
    return formatDate(d, 'yyyy-MM-dd', 'en');
  }

  MaxEndDateValue = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  MaxInitDateValue = this.MaxEndDateValue;
  MinStartDateValue: string | null = null;
  dateRangeError: boolean = false;

  showFilters: boolean = false;

  filtersForm = this.formBuilder.nonNullable.group({
    startDate: new FormControl<string | null>(this.defaultStartDate()),
    endDate: new FormControl<string | null>(formatDate(new Date(), 'yyyy-MM-dd', 'en')),
    entities: new FormControl<string | null>(null),
    category: new FormControl<number | null>(null),
    team: new FormControl<number | null>(null),
    withoutActivity: new FormControl<boolean | null>(false),
    search: new FormControl<string | null>(null),
  });

  filtersLstnr: Subscription = new Subscription;

  user: User = utils?.localStorageGetItem('user');

  categories: Category[] = [{ id: 1, name: 'OPERATIVE' }, { id: 2, name: 'DEMO' }];
  selectedCategory: string | null = null;
  selectedTeam: number | null = null;

  get teams() {
    return this.configSvc.currentConfigValue.teams ?? [];
  }

  constructor(
    public configSvc: ConfigService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {

    this.filtersForm.get('startDate')!.addValidators(CustomValidators.maxIntervalOneyear(this.filtersForm))
    this.filtersForm.updateOn
    this.filtersLstnr = this.filtersForm.valueChanges.subscribe(filter => {
      if (!this.filtersForm.pristine) {
        this.apply_filters_pb = true;
      }
    });

  }

  ngAfterViewInit() {
    this.triggerChildReset();
    /*this.filtersForm.patchValue({
      startDate: null,
      endDate: formatDate(new Date(), 'yyyy-MM-dd', 'en'),
      entities: null,
      category: null,
      team: null,
      withoutActivity: false,
      search: ''
    });*/
    //this.MaxInitDateValue = this.filtersForm.get('endDate')!.value ? this.filtersForm.get('endDate')!.value : formatDate(new Date(), 'yyyy-MM-dd', 'en');
  }
  ngOnDestroy(): void {
    this.filtersLstnr.unsubscribe();
  }

  applyFilters() {
    if (this.dateRangeError) return;
    let entities_filtered: string | null = null;
    switch (this.typeData) {
      case 'gazeMapsAnalytics':
        this.configSvc.setConfigParamsValue('gazeMapsEntitiesAnalyticsSelectedApplied', this.configSvc.currentConfigValue.gazeMapsEntitiesAnalyticsSelected);
        localStorage.setItem('gazeMapsAnalyticsFilter', JSON.stringify(this.filtersForm.value));
        entities_filtered = this.configSvc.currentConfigValue.gazeMapsEntitiesAnalyticsSelectedApplied?.filter((entity: Entity) => entity.entityTypeId === 4).map((entity: Entity) => entity.id ).join(',');
        break;
      case 'fitsAnalytics':
        this.configSvc.setConfigParamsValue('fitsEntitiesAnalyticsSelectedApplied', this.configSvc.currentConfigValue.fitsEntitiesAnalyticsSelected);
        localStorage.setItem('fitAnalyticsFilter', JSON.stringify(this.filtersForm.value));
        entities_filtered = this.configSvc.currentConfigValue.fitsEntitiesAnalyticsSelectedApplied?.filter((entity: Entity) => entity.entityTypeId === 4).map((entity: Entity) => entity.id ).join(',')
        break;
      default:
        break;
    }
    this.filtersForm.get('entities')!.patchValue(entities_filtered ? entities_filtered : null);
    this.apply_filters_pb = false;
    this.filters_applyed = true;
    this.reload.emit(this.filtersForm.value);
  }

  toogleFilters() {
    this.showFilters = !this.showFilters;
  }

  resetFilter(_filter: string) {
    /*this.apply_filters_pb = true;
    switch (_filter) {
      case 'entityFilter':
        this.selectedEntity = '';
        break
      case 'categoryFilter':
        this.selectedCategory = null;
        break
      default:
        break;
    }*/
  }

  cleanFilters() {
    switch (this.typeData) {
      case 'gazeMapsAnalytics':
        localStorage.removeItem('gazeMapsAnalyticsFilter');
        this.resetConfig('gazeMapsEntitiesAnalyticsSelected');
        break;
      case 'fitsAnalytics':
        localStorage.removeItem('fitsAnalyticsFilter');
        this.resetConfig('fitsEntitiesAnalyticsSelected');
        break;
      default:
        break;
    }
    this.filtersForm.patchValue({
      startDate: this.defaultStartDate(),
      endDate: formatDate(new Date(), 'yyyy-MM-dd', 'en'),
      entities: null,
      category: null,
      team: null,
      withoutActivity: false,
      search: null
    });
    this.selectedTeam = null;
    this.reload.emit(this.filtersForm.value);
    this.apply_filters_pb = false;
    this.filters_applyed = false;
    this.triggerChildReset();
  }

  resetConfig = (_param: String) => {
    this.configSvc.setConfigParamsValue(`${_param}`, null);
    this.configSvc.setConfigParamsValue(`${_param}Applied`, null);
  }

  onChange(e: any, _type: any) {
    if (e === '') this.filtersForm.get(_type)!.patchValue(null);

    const today = formatDate(new Date(), 'yyyy-MM-dd', 'en');

    if (_type === 'startDate') {
      const startVal = this.filtersForm.get('startDate')!.value;
      if (startVal) {
        const maxEnd = new Date(startVal);
        maxEnd.setMonth(maxEnd.getMonth() + this.MAX_MONTHS);
        this.MaxEndDateValue = formatDate(maxEnd < new Date() ? maxEnd : new Date(), 'yyyy-MM-dd', 'en');
      } else {
        this.MaxEndDateValue = today;
      }
    }

    if (_type === 'endDate') {
      const endVal = this.filtersForm.get('endDate')!.value;
      if (endVal) {
        const minStart = new Date(endVal);
        minStart.setMonth(minStart.getMonth() - this.MAX_MONTHS);
        this.MinStartDateValue = formatDate(minStart, 'yyyy-MM-dd', 'en');
      } else {
        this.MinStartDateValue = null;
      }
    }

    this.dateRangeError = this.checkDateRangeExceeded();
  }

  private checkDateRangeExceeded(): boolean {
    const start = this.filtersForm.get('startDate')!.value;
    const end = this.filtersForm.get('endDate')!.value;
    if (!start || !end) return false;
    const startDate = new Date(start);
    const endDate = new Date(end);
    const maxEnd = new Date(startDate);
    maxEnd.setMonth(maxEnd.getMonth() + this.MAX_MONTHS);
    const endDay = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    const maxEndDay = new Date(maxEnd.getFullYear(), maxEnd.getMonth(), maxEnd.getDate());
    return endDay > maxEndDay;
  }

  callbackPartners(e: any) {
    this.apply_filters_pb = true;
  }

  triggerChildReset() {
    this.childComp.resetSelection();
  }

}
